import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import ChartImage from "../../../../assets/images/CHPT/chart.png";
import ChartParty from "../../../../assets/images/CHPT/charty-party.png";
import Vector from "../../../../assets/images/CHPT/vector.png";
import { compose } from "redux";
import { withSocket } from "../../../../socket/context";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

const PlayingCards = (props) => {
  let roomData = _.get(props, "gameReducer.roomObj");
  const prompt = _.get(roomData, "game_state.prompt");
  const playerCards = _.get(roomData, "game_state.played_cards");

  //to dynamically adjust the size of cards based on the number of cards
  const setCardSize = (playedCards) => {
    if (playedCards.length < 6) {
      return {
        flexBasis: "22%",
        margin: 0,
        padding: 0,
      };
    } else if (playedCards.length < 14) {
      return {
        // width: 116,
        // height: 163,
        flexBasis: "15.5%",
        margin: 0,
        padding: 0,
      };
    } else {
      return {
        flexBasis: "12%",
        margin: 0,
        padding: 0,
      };
    }
  };

  return (
    <div className="w-100 h-100 smallCardsRow">
      <Row className="h-100 d-flex align-items-center">
        <Col md={7} className="d-flex">
          <div className="small-cards-wrapper">
            {playerCards.length > 0 &&
              playerCards.map((item) => {
                if (item.flipped) {
                  return (
                    <Card style={setCardSize(playerCards)}>
                      <CardBody>
                        <img src={item.card.url} />
                        {/* <div className="d-flex align-items-center px-1 justify-content-between">
                    <p className="mb-0 card-text">SUPER FUNNY Bit </p>
                    <div className="d-flex flex-column ">
                      <p className="y-text mb-0">Y</p>
                      <img src={Vector} alt="vector" />
                    </div>
                  </div>
                  <img src={ChartParty} alt="charty-party" className="mt-3" /> */}
                      </CardBody>
                    </Card>
                  );
                }
              })}
            {/* <Card>
            <CardBody>
              <div className="d-flex align-items-center px-1 justify-content-between">
                <p className="mb-0 card-text">SUPER FUNNY Bit </p>
                <div className="d-flex flex-column ">
                  <p className="y-text mb-0">Y</p>
                  <img src={Vector} alt="vector" />
                </div>
              </div>
              <img src={ChartParty} alt="charty-party" className="mt-3" />
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center px-1 justify-content-between">
                <p className="mb-0 card-text">SUPER FUNNY Bit </p>
                <div className="d-flex flex-column ">
                  <p className="y-text mb-0">Y</p>
                  <img src={Vector} alt="vector" />
                </div>
              </div>
              <img src={ChartParty} alt="charty-party" className="mt-3" />
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center px-1 justify-content-between">
                <p className="mb-0 card-text">SUPER FUNNY Bit </p>
                <div className="d-flex flex-column ">
                  <p className="y-text mb-0">Y</p>
                  <img src={Vector} alt="vector" />
                </div>
              </div>
              <img src={ChartParty} alt="charty-party" className="mt-3" />
            </CardBody>
          </Card> */}
          </div>
        </Col>
        <Col md={5} className="d-flex align-items-center">
          <div className="eval-chart-image">
            <img src={prompt.url} at="" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(PlayingCards);
